"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var tabs_1 = __importDefault(require("relements/build/esm/ui/tabs"));
// Constants
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var const_1 = require("@src/const");
// helpers
var hslBuilder_1 = __importDefault(require("@haptik/helpers/build/esm/hslBuilder"));
var hslDisplay_1 = __importDefault(require("@haptik/helpers/build/esm/hslDisplay"));
// Store
var store_1 = __importDefault(require("@src/store"));
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
// Components
var OCDropdown_1 = __importDefault(require("@src/components/OCDropdown"));
var RHSLoader_1 = __importDefault(require("@src/components/BotResponses/RHSLoader"));
var Slider_1 = __importDefault(require("@src/components/Slider"));
var OCInfo_1 = __importDefault(require("@src/components/OCInfo"));
// Actions
var BotActions_1 = require("@src/actions/BotActions");
// Styled-Components
var StyledComponets_1 = require("./StyledComponets");
var FollowUpMessageContainer = function (_a) {
    var _b;
    var handleFollowUpMessage = _a.handleFollowUpMessage, currentChannelId = _a.currentChannelId, webSDKSaved = _a.webSDKSaved, value = _a.value, onChange = _a.onChange, currentLanguageCode = _a.currentLanguageCode, handleOCDropdownChange = _a.handleOCDropdownChange, currentChannelName = _a.currentChannelName, isTranslateLoading = _a.isTranslateLoading, followupEnabled = _a.followupEnabled, handleToggle = _a.handleToggle, followupDelay = _a.followupDelay, _c = _a.disabled, disabled = _c === void 0 ? false : _c, platformIdsPresent = _a.platformIdsPresent, handleReset = _a.handleReset, allLanguages = _a.allLanguages, setCurrentLanguage = _a.setCurrentLanguage, currentHybridLanguage = _a.currentHybridLanguage, setCurrentHybridLanguage = _a.setCurrentHybridLanguage, _d = _a.isEdit, isEdit = _d === void 0 ? false : _d;
    var followUpMessage = value && value.length ? value : [''];
    var renderHSL = function () {
        var hslProps = {
            value: followUpMessage,
            withVariants: true,
            withReplies: true,
            onChange: function (value) { return onChange(value); },
            currentChannelName: currentChannelName,
        };
        if (!disabled) {
            return (react_1["default"].createElement(hslBuilder_1["default"], __assign({ isRephraseEnabled: store_1["default"].getFeatureFlag(MogamboConstants_1.FEATURE_FLAG_DATA.FLAGS.ENABLE_REPHRASE_RESPONSES) && currentLanguageCode === 'en', baseUrl: const_1.BASE_URL }, hslProps)));
        }
        return react_1["default"].createElement(hslDisplay_1["default"], __assign({}, hslProps));
    };
    var renderFollowUpMessageContainerHeader = function () {
        return (react_1["default"].createElement(box_1["default"], { padding: "0", width: "390px", justifyContent: "space-between", alignItems: "center", marginLeft: "24px" },
            react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold", color: "black.haptik" }, "Follow Up Message"),
            react_1["default"].createElement(toggle_1["default"], { value: followupEnabled, onChange: handleToggle, disabled: disabled })));
    };
    var renderSliderContainer = function () {
        return (react_1["default"].createElement(box_1["default"], { marginLeft: "24px", padding: "0", flexDirection: "column" },
            react_1["default"].createElement(Slider_1["default"], { min: 1, max: 60, step: 1, leftLabel: "1s", rightLabel: "60s", labelMarginTop: "-7px", value: followupDelay, onChange: handleFollowUpMessage, disabled: disabled })));
    };
    var renderHslVariantsContainer = function () {
        return (react_1["default"].createElement(box_1["default"], { style: {
                paddingLeft: 0,
                flexDirection: 'column',
                maxWidth: 390,
                marginTop: '12px',
                marginLeft: '24px',
                zIndex: '0',
            } },
            react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, "Variants"),
            react_1["default"].createElement(StyledComponets_1.HSLWrapper, null, !isTranslateLoading ? (renderHSL()) : (react_1["default"].createElement(RHSLoader_1["default"], { relativeAlign: true, text: "Loading " + currentChannelName + " translations" })))));
    };
    // Function to get the list of languages which needs to be shown in dropdown
    var getLanguagesOptions = function () {
        var uniqueLanguages = [];
        Object.keys(allLanguages).forEach(function (code) {
            allLanguages[code].forEach(function (lang) {
                if (lang.code === lang.script) {
                    uniqueLanguages.push(lang);
                }
            });
        });
        return uniqueLanguages;
    };
    // To get the complete language object for the selected language
    var getSelectedLanguage = function (code) {
        var language;
        allLanguages[code].forEach(function (item) {
            if (item.code === code) {
                language = item;
            }
        });
        return language.name;
    };
    var renderHybridLanguageTabs = function () {
        var _a;
        var tabData = [];
        (_a = allLanguages[currentLanguageCode]) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            tabData.push(react_1["default"].createElement(tabs_1["default"].Item, { value: item.script, onClick: function () {
                    if (isEdit) {
                        BotActions_1.createAlert('Please save changes first to change language', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return;
                    }
                    handleOCDropdownChange('5', 'WebSDK', false);
                    setCurrentHybridLanguage(item.script);
                } }, item.native_name));
        });
        return tabData;
    };
    var onLanguageChange = function (language) {
        var _a;
        if (isEdit) {
            BotActions_1.createAlert('Please save changes first to change language', 3000, MogamboConstants_1.AlertTypes.NEGATIVE);
            return;
        }
        setCurrentLanguage(language.code);
        var allHybridLanguages = (_a = CommonStore_1["default"].getMetaTags()) === null || _a === void 0 ? void 0 : _a.allHybridLanguages;
        var isHybridLanguagePresent = allHybridLanguages === null || allHybridLanguages === void 0 ? void 0 : allHybridLanguages[language.code];
        if (language.code === 'hi' && (isHybridLanguagePresent === null || isHybridLanguagePresent === void 0 ? void 0 : isHybridLanguagePresent.length) &&
            (isHybridLanguagePresent === null || isHybridLanguagePresent === void 0 ? void 0 : isHybridLanguagePresent.length) > 1) {
            setCurrentHybridLanguage(MogamboConstants_1.DEFAULT_LANGUAGE);
        }
        else {
            setCurrentHybridLanguage(language.code);
        }
        handleOCDropdownChange('5', 'WebSDK', false);
    };
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { flexDirection: "column", padding: "24px 24px 24px 0px", borderStyle: "solid", borderColor: "grey.haptik", borderWidth: "1px", width: "770px", borderRadius: "8px", backgroundColor: "grey.pastel", marginTop: "16px" },
            renderFollowUpMessageContainerHeader(),
            react_1["default"].createElement(StyledComponets_1.StyledText, { variant: "body.md", color: "grey.deep", marginTop: "13px", marginBottom: "34px", marginLeft: "24px" },
                "Send follow up messages to user after",
                ' ',
                followupEnabled ? followupDelay : 'few',
                " seconds."),
            followupEnabled && (react_1["default"].createElement(react_1["default"].Fragment, null,
                renderSliderContainer(),
                getLanguagesOptions().length > 1 && (react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Select a Language", className: "languageSelect", options: getLanguagesOptions(), optionKey: "name", label: "Language", value: getSelectedLanguage(currentLanguageCode), onChange: onLanguageChange, style: StyledComponets_1.languageDropdownStyles })),
                ((_b = allLanguages[currentLanguageCode]) === null || _b === void 0 ? void 0 : _b.length) > 1 && (react_1["default"].createElement(StyledComponets_1.TabWrapper, null,
                    react_1["default"].createElement(tabs_1["default"], { themed: true, value: currentHybridLanguage }, renderHybridLanguageTabs()))),
                react_1["default"].createElement(OCDropdown_1["default"], { selectedChannel: parseInt(currentChannelId, 10), onOCDropDownChange: handleOCDropdownChange, showChannelChangeError: webSDKSaved, style: {
                        maxWidth: 390,
                        paddingLeft: '24px',
                        paddingRight: '24px',
                        marginTop: '12px',
                    } }),
                currentChannelId !== '5' && !isTranslateLoading && (react_1["default"].createElement(box_1["default"], { padding: "0", width: "414px", marginLeft: "12px", flexDirection: "column" },
                    react_1["default"].createElement(OCInfo_1["default"], { synced: !(platformIdsPresent === null || platformIdsPresent === void 0 ? void 0 : platformIdsPresent.includes(currentChannelId.toString())), isAutoPreview: !MogamboConstants_1.AutoPreviewSupportedChannels.includes(Number(currentChannelId)), channelName: currentChannelName, onReset: handleReset }))),
                renderHslVariantsContainer())))));
};
exports["default"] = FollowUpMessageContainer;
